import { IDs } from '../../helpers/IDs';
import { getCO2Aequivalent } from './getCO2Aequivalent';

export function getEmissionsFaktorForTid(data: any, jahr: number, tid: number) {
    const et = data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER].find((e: any) => e.tid === tid);
    if (et) {
        return getEmissionsFaktor(data, '', jahr, et.co2_faktor);
    }
}

export function getEmissionsFaktorForName(data: any, jahr: number, name: string) {
    const et = data[IDs.ENT_ENERGIEDATEN_WAERME_ENERGIETRAEGER].find((e: any) => e.name === name);
    if (et) {
        return getEmissionsFaktor(data, '', jahr, et.co2_faktor);
    }
}

export function getEmissionsFaktor(data: any, kennzahl_kuerzel: string, jahr: number, field?: string) {
    // Hier gab es mal eine alte Variante mit einer anderen Tabelle
    // Der bereits auskommentierte Code wurde mit einem Commit am 14.03.2023 entfernt.
    const key_new = translateEmissionKey(field);
    const value_new = getCO2Aequivalent(data, jahr, key_new, false);
    // console.log('Emmission?', jahr, kennzahl_kuerzel, field, value, key_new, value_new.wert);
    return value_new.wert;
}

export function getEmissionsFaktorObject(data: any, kennzahl_kuerzel: string, jahr: number, field?: string) {
    // Hier gab es mal eine alte Variante mit einer anderen Tabelle
    // Der bereits auskommentierte Code wurde mit einem Commit am 14.03.2023 entfernt.
    const key_new = translateEmissionKey(field);
    const value_new = getCO2Aequivalent(data, jahr, key_new, false);
    // console.log('Emmission?', jahr, kennzahl_kuerzel, field, value, key_new, value_new.wert);
    return value_new;
}

export function translateEmissionKey(key: string) {
    switch (key) {
        case 'ottokraftstoff':
            return 'benzin';
        case 'strom_mix':
            return 'strom';
        case 'fernwaerme_mix':
            return 'fernwaerme';
        case 'heizoel_leicht':
            return 'hel';
        case 'hackschnitzel':
            return 'bio_hackschnitzel';
        case 'holzpellets':
            return 'bio_holzpellets';
        case 'biomasse_holz':
            return 'bio_brennholz';
    }
    return key;
}
